<template>
	<div class="background flex flex-col gap-8 text-center items-center pt-[10vh] h-screen w-full">
		<IconsFontAwesome
			icon="fa-solid fa-triangle-exclamation"
			class="text-text cautionSign" />

		<p class="page-title text-center">{{ $t("errorPageTitle") }}</p>

		<p class="text-text text-center">{{ $t("errorPageBody") }}</p>

		<FormBtn
			type="button"
			preset="primary"
			custom-class="w-60"
			:rounded="true"
			@click="navigateTo('/')">
			{{ $t("backToSite") }}
		</FormBtn>
	</div>
</template>

<script setup>
	const { t } = useI18n()

	//Set the Page Metadata
	useHead(() => {
		return {
			title: t("errorPageTitle"),
			meta: [{ name: "description", content: `Error` }],
		}
	})
</script>

<style lang="scss">
	.cautionSign {
		svg {
			@apply w-12 h-12;
		}
	}
</style>

<style lang="scss" scoped>
	.background {
		@apply bg-site;
	}
</style>
